import { ChangeEvent, FC } from 'react'

import { Button, Form, Input, Picker, Row, Select } from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import { IWorkingDocumentationRequest } from 'services/NGT/WorkingDocumentation'
import { SPACING } from 'utils'
import { TipoPendencia } from 'utils/types'

interface IFilterTableSearchDocumentationProps {
  workingDocumentation: IWorkingDocumentationRequest
  handlePesquisar: () => void
  errors: any
  areDatesValid: () => boolean
  handleClearForm: () => void
  handleOnChange: (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void
  tiposDocumento: TipoPendencia[]
}
const FilterTableSearchDocumentation: FC<IFilterTableSearchDocumentationProps> =
  ({
    handleOnChange,
    handlePesquisar,
    areDatesValid,
    handleClearForm,
    workingDocumentation,
    tiposDocumento,
    errors
  }) => {
    return (
      <Form
        onSubmit={() => {
          // eslint-disable-next-line no-unused-expressions
          null
        }}
      >
        <Row alignItems="center" justifyContent="start">
          <Input
            label="Contrato"
            formValue="cdContrato"
            value={workingDocumentation.cdContrato}
            placeholder="N°"
            marginRight={SPACING.spacing15}
            width="200px"
            onChange={handleOnChange}
            maxLength={100}
          />
          <Input
            label="Fornecedor"
            formValue="nmFornecedor"
            value={workingDocumentation.nmFornecedor}
            placeholder="Nome do Fornecedor"
            marginRight={SPACING.spacing15}
            onChange={handleOnChange}
            width="350px"
            maxLength={100}
          />
          <Picker
            label="Competência (Início)"
            value={workingDocumentation.competenciaInicio || null}
            maxDate={workingDocumentation.competenciaFim || null}
            formValue="competenciaInicio"
            errors={errors}
            onChange={(date) =>
              handleOnChange({
                target: { name: 'competenciaInicio', value: date }
              } as ChangeEvent<HTMLInputElement>)
            }
            placeholder="mm/aaaa"
            type="monthAndYear"
            marginRight={SPACING.spacing15}
          />
          <Picker
            label="Competência (Fim)"
            value={workingDocumentation.competenciaFim || null}
            minDate={workingDocumentation.competenciaInicio || null}
            formValue="competenciaFim"
            errors={errors}
            onChange={(date) =>
              handleOnChange({
                target: { name: 'competenciaFim', value: date }
              } as ChangeEvent<HTMLInputElement>)
            }
            type="monthAndYear"
            placeholder="mm/aaaa"
          />
        </Row>
        <Row
          alignItems="center"
          justifyContent="start"
          marginTop={SPACING.spacing20}
        >
          <Input
            label="CPF/Passaporte"
            formValue="cpf"
            mask={
              isNaN(parseInt(workingDocumentation.cpf))
                ? ['NN###########']
                : ['###.###.###-##']
            }
            value={workingDocumentation.cpf}
            onChange={handleOnChange}
            placeholder="N°"
            marginRight={SPACING.spacing15}
            width="200px"
            maxLength={15}
          />
          <Input
            label="Nome do Efetivo"
            formValue="nmEfetivo"
            value={workingDocumentation.nmEfetivo}
            onChange={handleOnChange}
            placeholder="Nome do Efetivo"
            marginRight={SPACING.spacing15}
            width="350px"
            maxLength={100}
          />
          <Select
            listOptions={tiposDocumento.map((doc) => ({
              label: doc.txDescricao,
              value: doc.idTipoPendencia
            }))}
            label="Tipo Documento"
            placeholder="Selecione"
            clearSelect={true}
            width="450px"
            formValue="idTipoDocumento"
            value={workingDocumentation.idTipoDocumento}
            onChange={handleOnChange}
          />
        </Row>
        <Row justifyContent="flex-end" marginTop={SPACING.spacing20}>
          <Button
            text="Limpar"
            variantButton="text"
            marginLeft={SPACING.spacing15}
            marginRight={SPACING.spacing15}
            marginBottom="20px"
            onClick={handleClearForm}
          />
          <Button
            endIcon={<MagnifyingGlassIcon />}
            onClick={handlePesquisar}
            disabled={!areDatesValid()}
            width="170px"
            marginBottom="20px"
            text="PESQUISAR"
          />
        </Row>
      </Form>
    )
  }

export default FilterTableSearchDocumentation
